@if (isNotLoggedIn$ | async) {
  <div [class]="styleClass()">
    <div class="rounded-sm p-8">
      <div class="mb-8 text-center text-xl">
        Zaloguj się lub załóż konto, aby zachować produkty na później, <br />
        śledzić swoje zamówienia i szybciej finalizować zakupy.
      </div>

      <div class="flex justify-center gap-4">
        <app-router-link
          [route]="Route.SignIn"
          [queryParams]="queryParams()">
          <app-slim-button
            maxWidth="16rem"
            label="Zaloguj się" />
        </app-router-link>

        <app-router-link
          [route]="Route.SignUp"
          [queryParams]="queryParams()">
          <app-slim-button
            maxWidth="16rem"
            theme="dark"
            label="Załóż konto" />
        </app-router-link>
      </div>
    </div>
  </div>
}
